module.exports = __webpack_public_path__ + "media/images/browsing-39b4aae40427986f5533db7de62abf3d.jpg";